// Added per Vince's Demo.
import { NavLink } from "react-router-dom";


export default function Links() {
    return (
        <ul>
            <li>
                <NavLink to="/">Home</NavLink>
            </li>
            <li>
                <NavLink to="/dashboard">Profile Page</NavLink>
            </li>
            <li>
                <NavLink to="/login">Login</NavLink>
            </li>
            <li>
                <NavLink to="/random">Random Place</NavLink>
            </li>
            <li>
                <NavLink to="/edit">Setup</NavLink>
            </li>
        </ul>
    );
}